import "./HouseholdInfoSummary.scss";
import * as React from "react";
import { HouseholdInfo } from "./HouseholdInfo";
import HouseholdDetails from "../patient-management/HouseholdDetails";
import EditAction from "../commons/components/action/EditAction";

export default function HouseholdInfoSummary({
  forMyself,
  householdInfo,
  editAction,
  showEditHouseholdInfoForm,
}: {
  forMyself: boolean;
  householdInfo?: HouseholdInfo;
  editAction: boolean;
  showEditHouseholdInfoForm: () => any;
}) {
  return (
    <div className="household-info-summary">
      <div className="panel-title h-flex space-between no-wrap">
        <div>{i18n["Page.Portal.HouseholdInformation.Title"]}</div>
        {editAction && <EditAction onClick={showEditHouseholdInfoForm} />}
      </div>
      <div>
        {editAction ? (
          <HouseholdDetails householdInfo={householdInfo} />
        ) : (
          <div className={"h-flex centered action-container"}>
            <button className="button-secondary small" onClick={showEditHouseholdInfoForm}>
              {
                i18n[
                  forMyself
                    ? "Page.Portal.HouseholdInformation.CompleteInformation.ForMyself.Button"
                    : "Page.Portal.HouseholdInformation.CompleteInformation.Button"
                ]
              }
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
